import { Slot } from '@radix-ui/react-slot';
import { cva } from 'class-variance-authority';
import * as React from 'react';

import { cn } from '@/lib/utils';

const badgeVariants = cva(
  'inline-flex items-center justify-center rounded-md border px-2 py-0.5 font-medium w-fit whitespace-nowrap shrink-0 [&>svg]:size-3 gap-1 [&>svg]:pointer-events-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive transition-[color,box-shadow] overflow-hidden',
  {
    variants: {
      variant: {
        SolidPrimary: 'bg-primary text-onColor shadow-sm',
        SolidBlue: 'bg-info-strong text-onColor shadow-sm',
        SolidGreen: 'bg-success-strong text-onColor shadow-sm',
        SolidRed: 'bg-error-strong text-onColor shadow-sm',
        SolidYellow: 'bg-warning-strong text-onColor shadow-sm',
        SoftSecondary: 'bg-secondary shadow-sm',
        SoftBlue: 'bg-info-muted text-info shadow-sm',
        SoftGreen: 'bg-success-muted text-success shadow-sm',
        SoftRed: 'bg-error-muted text-error shadow-sm',
        SoftGray: 'bg-secondary text shadow-sm',
        SoftYellow: 'bg-warning-muted text-warning shadow-sm',
        OutlinePrimary: 'bg text-muted border shadow-sm',
        OutlineBlue: 'bg text-info border-info-muted shadow-sm',
        OutlineGreen: 'bg text-success border-success shadow-sm',
        OutlineRed: 'bg text-error border-error-muted shadow-sm',
        OutlineYellow: 'bg text-warning border-warning-muted shadow-sm',
        SurfacePrimary: 'bg-secondary text-muted border shadow-sm',
        SurfaceBlue: 'bg-info-muted text-info border-info-muted shadow-sm',
        SurfaceGreen: 'bg-success-muted text-success border-success shadow-sm',
        SurfaceRed: 'bg-error-muted text-error border-error-muted shadow-sm',
        SurfaceYellow: 'bg-warning-muted text-warning border-warning-muted shadow-sm',
        SolidPrimaryBorderless: 'bg-primary border-none text-onColor shadow-sm',
      },
      size: {
        sm: 'text-xs px-2 py-0.5',
        md: 'text-sm px-2 py-0.5',
        lg: 'text-sm px-3 py-1',
      },
    },
    defaultVariants: {
      variant: 'SolidPrimary',
      size: 'md',
    },
  }
);

function Badge({ className, variant, asChild = false, ...props }) {
  const Comp = asChild ? Slot : 'span';
  return <Comp data-slot="badge" className={cn(badgeVariants({ variant }), className)} {...props} />;
}

export { Badge, badgeVariants };
